var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "gp7nqtkf6a",
    d: "M0 0H24V24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9o8nm1b6zb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gp7nqtkf6a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeWidth: 2,
    d: "M4.5 4.5L19.5 19.5",
    mask: "url(#9o8nm1b6zb)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeWidth: 2,
    d: "M4.5 4.5L19.5 19.5",
    mask: "url(#9o8nm1b6zb)",
    transform: "matrix(-1 0 0 1 24 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseBlack);
export default __webpack_public_path__ + "static/media/ic_close_black.cd58410c1bb0db22f43acdb285c553f5.svg";
export { ForwardRef as ReactComponent };